import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Eray Ozcan </span>
            from <span className="purple"> Belgium.</span>
            <br />
            I speak fluent English and Dutch.
            <br />
            I am currently looking for a job in IT as a developer or IT technician/support.
            <br />
            I am excited to have completed my Applied Computer Science degree (cum laude) in June 2025 at <span className="purple"> UCLL </span>!
            <br />
            <br />
            Apart from coding, some other activities that I love to do:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing bass guitar in a band
            </li>
            <li className="about-activity">
              <ImPointRight /> Photography
            </li>
            <li className="about-activity">
              <ImPointRight /> Content creation
            </li>
            <li className="about-activity">
              <ImPointRight /> Gaming
            </li>
            <li className="about-activity">
              <ImPointRight /> Running
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "I know how to google things."{" "}
          </p>
          <footer className="blockquote-footer">Eray</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
